import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {useAddTaskStore} from './add-task-store'
import {canCreateTask} from './can-create-task'

const TwError = tw.div`
  flex
  items-start
  gap-4
  text-status-error
  text-12
  leading-4
`

export const AddTaskError = observer(() => {
  const [state, store] = useAddTaskStore()

  useEffect(() => {
    if (state.isTriedCreateTask && !state.text) {
      store.error(Lang.msg.addTaskEmptyTextErrorMessage)
      return
    }
    if (state.isTriedCreateTask && !canCreateTask(state.requiredStickers)) {
      store.error(Lang.msg.addTaskStickerErrorMessage)
      return
    }

    store.error('')
  }, [state.requiredStickers, state.text])

  if (!state.error) {
    return null
  }

  return (
    <TwError>
      <Icon icon="IconAlertCircle" size={16} color="status-error" />
      <span className="flex-1 min-w-0 break-words">{state.error}</span>
    </TwError>
  )
})
